import React from 'react';
import AlarmIcon from './AlarmIcon';

const AlarmIconMulti = ({ data, tooltipDirection }) => {
  if (Array.isArray(data)) {
    const alarms = data;

    if (alarms?.length === 0) {
      return null;
    }

    const groupedStatus = alarms.some(alarm => alarm.status === 'active') ? 'active' : 'inactive';

    return (
      <AlarmIcon
        status={groupedStatus}
        tooltipDirection={tooltipDirection}
      />
    );
  }
  const alarm = data;

  return (
    <AlarmIcon
      status={alarm.status}
      isAcknowledged={alarm.isAcknowledged}
      acknowledgedBy={alarm.acknowledgedBy}
      acknowledgedTime={alarm.acknowledgedTime}
      tooltipDirection={tooltipDirection}
    />
  );

};

export default AlarmIconMulti;
